exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-pane{min-width:300px!important}.vc-select select{-webkit-appearance:none!important;-moz-appearance:none!important;appearance:none!important;background:transparent}", ""]);

// exports
